import React__default from 'react';
import { useApiClient, Products } from '@grandvisionhq/api-client';
import { useApiConfig } from '@grandvisionhq/state';

const useFetchBundleSolutions = (sku)=>{
    const { productsUrl  } = useApiConfig();
    const params = React__default.useMemo(()=>({
            sku
        })
    , [
        sku
    ]);
    const [loading, data] = useApiClient(Products.getContactLensBundles, {}, productsUrl, params);
    return [
        loading,
        data === null || data === void 0 ? void 0 : data.solutions
    ];
};

export { useFetchBundleSolutions };
//# sourceMappingURL=use-fetch-bundle-solutions.js.map
